import { render, staticRenderFns } from "./item-details.vue?vue&type=template&id=1e5f0dd5&scoped=true"
import script from "./item-details.vue?vue&type=script&lang=ts"
export * from "./item-details.vue?vue&type=script&lang=ts"
import style0 from "./item-details.vue?vue&type=style&index=0&id=1e5f0dd5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_169bdbd7e32539014db8c98595250064/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e5f0dd5",
  null
  
)

export default component.exports